/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./full-plan-name.component";
import * as i2 from "../../../core/translations/translations.service";
var styles_FullPlanNameComponent = [];
var RenderType_FullPlanNameComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_FullPlanNameComponent, data: {} });
export { RenderType_FullPlanNameComponent as RenderType_FullPlanNameComponent };
export function View_FullPlanNameComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(0, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.getFullPlanName(); _ck(_v, 0, 0, currVal_0); }); }
export function View_FullPlanNameComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "full-plan-name", [], null, null, null, View_FullPlanNameComponent_0, RenderType_FullPlanNameComponent)), i0.ɵdid(1, 49152, null, 0, i1.FullPlanNameComponent, [i2.Translations], null, null)], null, null); }
var FullPlanNameComponentNgFactory = i0.ɵccf("full-plan-name", i1.FullPlanNameComponent, View_FullPlanNameComponent_Host_0, { plan: "plan" }, {}, []);
export { FullPlanNameComponentNgFactory as FullPlanNameComponentNgFactory };
